import { Link } from "react-router-dom";
import "animate.css";
import "../css/Home.css";
import {
    BsChevronCompactDown,
    BsStarFill,
    BsArrowRightCircle,
    BsArrowLeftCircle,
} from "react-icons/bs";
import { useEffect, useRef } from "react";
import Lottie from "lottie-react";
import foodDeliveryAnimation from "../animation/food-delivery-animation.json";
import { useLocation } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { AnimationOnScroll } from "react-animation-on-scroll";

function Home() {
    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    const PhotoSettings = {
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 10000,
        infinite: true,
        variableWidth: true,
        cssEase: "linear",
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    const firstSection = useRef(null);
    const deliverySection = useRef(null);

    const { state } = useLocation();

    const scrollToSection = (elementRef) => {
        window.scrollTo({
            top: elementRef.current.offsetTop,
            behavior: "smooth",
        });

        // elementRef.current.scrollIntoView({
        //     behavior: "smooth",
        //     block: "center",
        // });
    };

    const reviews = [
        {
            name: "Michael Morgan",
            reviewOrg: "Google",
            body: "Go here now.!!! I can't remember the last time I ate somewhere and EVERYTHING about the food and experience was great, but like Kevin Hart said \"You gon learn today!\" The appetizer was great (the coconut shrimp 🔥), the service was great, the Pho was amazing we got the special with beef and meatballs, even the music was on point. Thinking of making this a regular date spot, and can't wait to go back soon.",
        },
        {
            name: "Itz B",
            reviewOrg: "Google",

            body: "This place is so good!!! I ordered the spicy soup and it’s amazing. It’s the perfect amount of spice (it’s quite spicy) but the spice doesn’t overtake the flavor of the broth. It’s my second time here and I’m not disappointed:) staff is very friendly and the beef dumplings are very good!! If you are looking for a place to eat with friends, family, even a date, I would definitely recommend this place!",
        },
        {
            name: "D.L.",
            reviewOrg: "Yelp",
            body: "We LOVE Pho and recently relocated to Lubbock from Phoenix. After trying a couple of Pho places that were just OK, we found this place and it will definitely be our regular spot. The oxtail pho was amazing and so was the build-your-own pho. We also got the spring rolls and dumplings- both appetizers were awesome. Highly recommend this place!!! SO GOOD! \n\n The ambience is also great and the owner walked around asking how the food was- pride of ownership is apparent by the food and the staff.",
        },
        {
            name: "Julia P.",
            reviewOrg: "Yelp",
            body: "i get takeout from here all the time and the prices are good, service is amazing, and the food is just so good every single time. the staff is always so nice, and my food is extremely hot every time i get home. every time. just LOVE this place!",
        },
    ];

    const slider = useRef(null);

    useEffect(() => {
        if (state && state.order) {
            scrollToSection(deliverySection);
            //window.history.replaceState({}, document.title);
        }
    }, [state]);

    return (
        <>
            <div className="bg-gradient-to-br from-white to-violet-100">
                <div className="w-full h-screen mx-auto overflow-hidden bg-transparent font-manrope">
                    <div
                        id="homepage-bg-image"
                        className="relative h-full p-12 bg-center bg-no-repeat bg-cover animate-scaleBg"
                        style={{
                            backgroundImage: `url(./img/jumbotron.jpg)`,
                        }}
                    >
                        <div
                            id="homepage-bg-overlay"
                            className="absolute top-0 bottom-0 left-0 right-0 w-full h-full bg-fixed"
                            style={{ backgroundColor: `rgba(255,255,255,0.1)` }}
                        />
                    </div>

                    <div
                        id="homepage-bg-info"
                        className="absolute top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center w-full h-full text-center text-white p-11"
                    >
                        <p
                            className="justify-center text-6xl md:text-9xl drop-shadow-2xl font-kaushan animate__animated animate__fadeInDown"
                            style={{ textShadow: "8px 3px 3px black" }}
                        >
                            Taste the Flavor of Vietnam!
                        </p>

                        <Link to="/Menu">
                            <button
                                type="button"
                                className="px-20 pt-3 pb-3 mt-20 text-lg font-extrabold leading-normal text-white transition duration-200 ease-in-out border-2 border-white rounded bg-neutral-100/10 backdrop-blur-sm md:text-2xl font-manrope animate__animated animate__fadeInDown hover:border-neutral-100 hover:bg-neutral-50 hover:text-black"
                            >
                                VIEW MENU
                            </button>
                        </Link>
                    </div>

                    <BsChevronCompactDown
                        className="absolute left-0 right-0 m-auto transition duration-200 transform cursor-pointer hover:scale-125 text-neutral-200 bottom-5"
                        onClick={() => scrollToSection(firstSection)}
                        size={"100px"}
                    />
                </div>

                <div ref={firstSection} className="w-full font-manrope">
                    <div className="flex items-center justify-center min-h-screen p-10 space-x-8 bg-gradient-to-r from-neutral-50/50 to-teal-50 lg:flex-row">
                        <AnimationOnScroll
                            animateIn="animate__fadeIn"
                            className="flex flex-col lg:space-x-8 lg:flex-row"
                            animateOnce
                        >
                            <img
                                src="./img/restaurant2.jpeg"
                                alt="Restaurant"
                                className="h-auto shadow-xl lg:w-1/2"
                            />
                            <div className="flex items-center justify-center lg:w-1/2">
                                <div className="flex flex-col">
                                    <h1 className="mt-10 text-4xl font-extrabold text-center lg:text-left lg:text-6xl">
                                        Located in{" "}
                                        <span className="bg-teal-200 highlight">
                                            Lubbock!
                                        </span>
                                    </h1>
                                    <p className="py-5 md:text-lg">
                                        We are so glad to bring in and share the
                                        Vietnamese food culture in Lubbock,
                                        Texas! Lubbock is a rapidly growing city
                                        with a very strong local economy and
                                        exciting people. It is also the home of
                                        the famous Texas Tech University that
                                        promotes diversity and enrich values to
                                        produce leaders of the future. We are
                                        both honored and privileged to be part
                                        of the community that serves nothing but
                                        good Vietnamese food that everyone will
                                        enjoy!
                                    </p>
                                    <p className="mb-10 md:text-lg">
                                        We are located along 19th and Quaker
                                        Ave. (Near Market Street) and we are
                                        open every day of the week! For more
                                        information about our location and
                                        service hours, click below!
                                    </p>

                                    <div className="flex items-center justify-center p-5">
                                        <Link to="/contact">
                                            <button
                                                type="button"
                                                className="px-10 py-5 text-lg leading-normal transition duration-300 transform bg-gray-700 rounded shadow-xl text-neutral-200 hover:scale-110"
                                            >
                                                More Information
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </AnimationOnScroll>
                    </div>

                    <div className="min-h-screen p-10 bg-gradient-to-l from-neutral-50/50 to-green-50">
                        <AnimationOnScroll
                            animateIn="animate__zoomIn"
                            className="flex flex-col pt-20 lg:flex-row"
                            animateOnce
                        >
                            <div className=" lg:w-2/6">
                                <h1 className="px-3 py-5 text-4xl font-extrabold text-center lg:text-left lg:text-6xl">
                                    Food is always{" "}
                                    <span className="bg-green-200 highlight">
                                        Fresh!
                                    </span>
                                </h1>
                                <p className="px-3 py-5 md:text-lg">
                                    We take pride in making our Food as
                                    delicious as it can be and freshness is one
                                    of the key factor in doing so. We always
                                    create new batches everyday and everything
                                    is cooked as soon as you place an order in
                                    the restaurant!
                                </p>
                            </div>
                            <div className="flex flex-row h-full mt-10 lg:mt-0 lg:w-4/6">
                                <div className="flex lg:w-1/2 lg:flex-col">
                                    <div className="lg:h-1/2">
                                        <img
                                            src="./img/com.jpg"
                                            alt="Chicken Fried Rice"
                                            className="ml-auto rounded-full lg:rounded-none lg:w-1/2"
                                        />
                                    </div>
                                    <div className="lg:h-1/2">
                                        <img
                                            src="./img/bunbohue.jpg"
                                            alt="Noodle Soup"
                                            className="ml-auto scale-125 rounded-full lg:scale-110 lg:shadow-lg lg:w-4/6 lg:rounded-none lg:shadow-blue-200"
                                        />
                                    </div>
                                </div>
                                <div className="flex items-center justify-start lg:w-1/2">
                                    <img
                                        src="./img/pho.jpg"
                                        alt="Noodle Soup"
                                        className="rounded-full lg:shadow-lg lg:w-3/4 lg:shadow-green-200 lg:scale-125 lg:rounded-none lg:h-4/6"
                                    />
                                </div>
                            </div>
                        </AnimationOnScroll>
                    </div>

                    <div className="flex flex-col items-center justify-center w-full pt-10 max-h-[500px] bg-neutral-50/60">
                        <div className="w-full mt-10 max-w-max">
                            <Slider {...PhotoSettings}>
                                <a
                                    href="https://www.instagram.com/phodistrictt1_/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img
                                        src="/img/photo1.jpg"
                                        alt="Vietnamese Sandwich"
                                        className="md:h-[500px] md:w-[500px] h-72 w-72"
                                    />
                                </a>
                                <a
                                    href="https://www.instagram.com/phodistrictt1_/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img
                                        src="/img/photo2.jpg"
                                        alt="Chicken Vermicelli"
                                        className="md:h-[500px] md:w-[500px] h-72 w-72"
                                    />
                                </a>
                                <a
                                    href="https://www.instagram.com/phodistrictt1_/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img
                                        src="/img/photo3.jpg"
                                        alt="Spicy Beef Noodle Soup"
                                        className="md:h-[500px] md:w-[500px] h-72 w-72"
                                    />
                                </a>
                                <a
                                    href="https://www.instagram.com/phodistrictt1_/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img
                                        src="/img/photo4.jpg"
                                        alt="Grapefruit Sunset Tea"
                                        className="md:h-[500px] md:w-[500px] h-72 w-72"
                                    />
                                </a>
                                <a
                                    href="https://www.instagram.com/phodistrictt1_/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img
                                        src="/img/photo5.jpg"
                                        alt="Fried Rice"
                                        className="md:h-[500px] md:w-[500px] h-72 w-72"
                                    />
                                </a>
                            </Slider>
                        </div>
                    </div>

                    <div ref={deliverySection} className="w-full p-10 ">
                        <AnimationOnScroll
                            animateIn="animate__slideInLeft"
                            animateOnce
                            className="flex flex-col"
                        >
                            <Lottie
                                animationData={foodDeliveryAnimation}
                                loop={true}
                                className="self-center w-1/2"
                            />
                            <h1 className="py-5 text-4xl font-extrabold text-center lg:text-6xl">
                                Delivering{" "}
                                <span className="highlight bg-violet-200">
                                    Happiness!
                                </span>
                            </h1>
                            <p className="text-center md:text-lg">
                                We understand that you have a lot of things to
                                do but that does not take away your cravings for
                                Vietnamese food!
                            </p>
                            <span className="mt-20 text-xl text-center md:text-3xl">
                                For pickup orders, call us at:
                            </span>
                            <a
                                href="tel:8064075585"
                                className="mt-10 text-3xl font-extrabold text-center md:text-6xl"
                            >
                                806-407-5585
                            </a>
                            <p className="mt-20 text-xl font-extrabold text-center md:text-3xl">
                                We are available in the following food services:
                            </p>

                            <div className="flex flex-col">
                                <div className="flex flex-row items-stretch justify-center w-full mt-10 space-x-8">
                                    <a
                                        href="https://www.ubereats.com/store/pho-district-1/nCUz0_muRMGbCaG4pw4kJg"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="flex items-center justify-center w-1/2 px-5 duration-150 ease-in border-t-[15px] shadow-lg hover:bg-gradient-to-tr hover:from-neutral-50 hover:to-green-50 bg-neutral-50 border-neutral-600 hover:scale-110 md:px-10 lg:w-1/4 hover:bg-neutral-50"
                                    >
                                        <img
                                            src="./img/ubereats.png"
                                            alt="Link to Uber Eats"
                                        />
                                    </a>
                                    <a
                                        className="flex items-center justify-center w-1/2 px-5 duration-150 ease-in border-t-[15px] shadow-lg hover:bg-gradient-to-tr hover:from-neutral-50 hover:to-red-50 bg-neutral-50 border-neutral-600 md:px-10 lg:w-1/4 hover:scale-110 hover:bg-neutral-50"
                                        href="https://www.skiplinow.com/shop/863642a"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <img
                                            src="./img/skipli.png"
                                            alt="Link to Skipli"
                                        />
                                    </a>
                                </div>
                                <div className="flex flex-row items-stretch justify-center w-full mt-10 space-x-8">
                                    <a
                                        href="https://www.grubhub.com/restaurant/pho-district-1-1910-quaker-ave-lubbock/3303860"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="flex items-center justify-center w-1/2 px-5 duration-150 ease-in border-t-[15px] shadow-lg bg-neutral-50 hover:bg-gradient-to-tr hover:from-neutral-50 hover:to-orange-50 border-neutral-600 md:px-10 lg:w-1/4 hover:scale-110"
                                    >
                                        <img
                                            src="./img/grubhub.png"
                                            alt="Link to GrubHub"
                                        />
                                    </a>
                                    <a
                                        href="https://www.doordash.com/store/pho-district-1-lubbock-23268406/"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="flex items-center justify-center w-1/2 p-10 duration-150 ease-in shadow-lg border-t-[15px] border-neutral-600 bg-neutral-50 md:p-20 lg:w-1/4 hover:scale-110 hover:bg-gradient-to-tr hover:from-neutral-50 hover:to-red-100"
                                    >
                                        <img
                                            src="./img/doordash.png"
                                            alt="Link to Doordash"
                                        />
                                    </a>
                                </div>
                            </div>
                        </AnimationOnScroll>
                    </div>

                    <div className="flex flex-col items-center justify-center w-full p-10 mt-20">
                        <h1 className="text-4xl font-extrabold text-center lg:text-6xl">
                            Check our{" "}
                            <span className="highlight bg-amber-300">
                                Reviews!
                            </span>
                        </h1>
                        <div className="flex flex-row items-center justify-center w-full mt-10 space-x-4 text-center lg:space-x-8">
                            <BsArrowLeftCircle
                                onClick={() => slider?.current?.slickPrev()}
                                className="duration-200 transform w-7 h-7 md:h-10 md:w-10 hover:scale-125"
                            />
                            <div className="items-stretch w-3/4 mb-20 max-w-max">
                                <Slider {...settings} ref={slider}>
                                    {reviews.map((review, index) => (
                                        <div
                                            key={index}
                                            className="p-5 text-center md:p-20 backdrop-blur bg-white/60"
                                        >
                                            <h3 className="text-2xl font-extrabold md:text-4xl">
                                                {review.name}
                                            </h3>

                                            <div className="flex flex-row items-center justify-center mt-5">
                                                <BsStarFill
                                                    fill="gold"
                                                    className="w-5 h-5 md:h-7 md:w-7 "
                                                />
                                                <BsStarFill
                                                    fill="gold"
                                                    className="w-5 h-5 md:h-7 md:w-7 "
                                                />
                                                <BsStarFill
                                                    className="w-5 h-5 md:h-7 md:w-7 "
                                                    fill="gold"
                                                />
                                                <BsStarFill
                                                    fill="gold"
                                                    className="w-5 h-5 md:h-7 md:w-7 "
                                                />
                                                <BsStarFill
                                                    fill="gold"
                                                    className="w-5 h-5 md:h-7 md:w-7 "
                                                />
                                            </div>
                                            <h4 className="mt-5 text-xl italic md:text-3xl">
                                                {review.reviewOrg + " Review"}
                                            </h4>
                                            <p className="text-sm md:text-xl mt-7">
                                                {review.body}
                                            </p>
                                        </div>
                                    ))}
                                </Slider>
                            </div>

                            <BsArrowRightCircle
                                onClick={() => slider?.current?.slickNext()}
                                className="duration-200 transform w-7 h-7 md:h-10 md:w-10 hover:scale-125"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Home;
